import type { TransKey } from '@root/shared/localization'

export type PingQuality = 'good' | 'average' | 'bad' | 'disconnected'

export const QUALITY_COLOR_MAP: Record<PingQuality, string> = {
  good: 'var(--success-8)',
  average: 'var(--success-8)',
  bad: 'var(--success-8)',
  disconnected: 'var(--error-10)',
}
export const QUALITY_TRANSLATION_MAP: Record<PingQuality, TransKey> = {
  good: 'latency.connected',
  average: 'latency.connected',
  bad: 'latency.connected',
  disconnected: 'latency.disconnected',
}

export const latencyToQuality = (latency: number | undefined): PingQuality => {
  if (latency === undefined) {
    return 'disconnected'
  } else if (latency <= 100) {
    return 'good'
  } else if (latency <= 250) {
    return 'average'
  }

  return 'bad'
}

export const fpsToQuality = (fps: number | undefined): PingQuality => {
  if (fps === undefined || fps === 0) {
    return 'disconnected'
  } else if (fps >= 50) {
    return 'good'
  } else if (fps >= 30) {
    return 'average'
  }

  return 'bad'
}
